import $ from 'jquery'; 
window.$ = window.jQuery = $;
import Quill from 'Quill';
// ************ Hover Start*************** //
let  quill = null;
var $cjsType ,$cjsParam , $curEle ,$curEleName, $curParentEle ,$curEleWidth ,$cjs_badge_div ,CjsTxt,$inputTxt;

function cjs_change_text(el,type){
   /* alert("data");*/

     CjsTxt = '';
     let cjsTop,cjsLeft
    if(type==1){
        el.addClass('cjs-badge-del');
        $cjs_badge_div = '<div class="cjs-badge" ><div class="cjs-badge-del-text">Delete</div> </div>';
         cjsTop = (el.offset().top - 15) <= 0 ? 0 : ((el.offset().top + 5)) ;
         cjsLeft = (el.offset().top ) <= 0 ? el.offset().left + el.width()  : (el.offset().left + el.width() + 30);
       
    }else if(type==2){
        el.addClass('cjs-badge-copy');
        $cjs_badge_div = '<div class="cjs-badge" ><div class="cjs-badge-copy-text">Copy</div></div>';
         cjsTop = (el.offset().top - 15) <= 0 ? 0 : ((el.offset().top + 5)) ;
         cjsLeft = (el.offset().top ) <= 0 ? el.offset().left + el.width()  : (el.offset().left + el.width() + 30);
       
    }else if(type==3){
        el.addClass('cjs-badge-copy-del');
        $cjs_badge_div = '<div class="cjs-badge cjs-badge-copy-del-div " ><div class="cjs-badge-copy-text">Copy</div> <div class="cjs-badge-del-text">Delete</div> </div>';
         cjsTop = (el.offset().top - 15) <= 0 ? 0 : ((el.offset().top + 5)) ;
         cjsLeft = (el.offset().top ) <= 0 ? el.offset().left + el.width()  : (el.offset().left + el.width() - 15);
       
    }else{
         $cjs_badge_div = '<div class="cjs-badge"><div class="cjs-badge-name"></div> </div>';
         cjsTop = (el.offset().top - 15) <= 0 ? 0 : ((el.offset().top - 20)) ;
         cjsLeft = (el.offset().top ) <= 0 ? el.offset().left + 0 : el.offset().left - 5;
       
    }
    $curEle = el;
    
    
    $("body .cjs-badge:first").remove();
    $('body').prepend($cjs_badge_div);
    $('.cjs-badge-name').text(CjsTxt);
    $('.cjs-badge').show();
    $('.cjs-badge').css({"top":cjsTop+"px", "left":cjsLeft+"px"});
}


function cjs_text_mouse_enter(e, ele,type=0){
    $curEleHover = e.target;
    $curEleNameHover = $curEleHover.nodeName.toLowerCase();
    if( $curEleNameHover === 'a' ) {
        $hrefVal = e.target.getAttribute('href');
        if($hrefVal.charAt(0)!='#'){
            ele.attr('href','#'+$hrefVal);
        }
    }
    if($('body').hasClass('cjs-selected-item')){

    }else{
        if(type!=0){
            cjs_change_text(ele,type);
        }else{
            if(ele.hasClass('cjs-change-title')){
                cjs_change_text(ele,type);
            }
        }
        
     }

}


function cjs_text_mouse_leave(e, ele,type=0){

    $curEleHover = e.target;
        $curEleNameHover = $curEleHover.nodeName.toLowerCase();
        if( $curEleNameHover === 'a' ) {
            $hrefVal = e.target.getAttribute('href');
            if($hrefVal.charAt(0)!='#'){
                ele.attr('href',$hrefVal.substr(1));
            }
        }
       if($('body').hasClass('cjs-selected-item')){

        }else{
            if(type==1){
                ele.removeClass('cjs-badge-del'); 
            }else if(type==2){
                ele.removeClass('cjs-badge-copy'); 
            }else if(type==3){
                ele.removeClass('cjs-badge-copy-del'); 
            } 
            $('.cjs-badge').remove();
        }

}
    
$(document).ready(function(){
    /*$saveTemplateHtml = '<div class="cjs-loader"><div class="cjs-loader-item">Loading.....</div></div><div class="cjs-save-template-div"><button class="cjs-save-btn">Save Template</button></div>';

    $("body").prepend($saveTemplateHtml);*/
});            

 $(document).on({
    mouseenter: function (e) {
        cjs_text_mouse_enter(e, $(this));
    },
    mouseleave: function (e) {
       cjs_text_mouse_leave(e, $(this));
    }
}, ".cjs-change-title"); 


$(document).on({
    mouseenter: function (e) {
        cjs_text_mouse_enter(e, $(this),1);
    },
    mouseleave: function (e) {
       cjs_text_mouse_leave(e, $(this),1);
    }
}, ".cjs-change-title-with-del"); 


$(document).on({
    mouseenter: function (e) {
        cjs_text_mouse_enter(e, $(this),2);
    },
    mouseleave: function (e) {
       cjs_text_mouse_leave(e, $(this),2);
    }
}, ".cjs-change-title-with-copy"); 


$(document).on({
    mouseenter: function (e) {
        cjs_text_mouse_enter(e, $(this),3);
    },
    mouseleave: function (e) {
       cjs_text_mouse_leave(e, $(this),3);
    }
}, ".cjs-change-title-copy-del"); 
// ************ Hover Ends *************** //




function cjs_delete(ele){
    ele.remove();

}
function cjs_copy(ele){
    console.log(ele.index());
    //alert(ele.index());
    if(ele.hasClass('cjs-change-text-copy-del')){
        ele.clone().insertAfter(ele);
     }else{
        ele.addClass('cjs-change-text-copy-del').clone().insertAfter(ele);
        ele.removeClass('cjs-change-text-copy-del');

    }
    
}

$(document).on('click','.cjs-badge-del', function(e) {
    cjs_delete($curEle);
});

$(document).on('click','.cjs-badge-copy', function(e) {
    cjs_copy($curEle);
});
// cjs-change-title
$(document).on('click','.cjs-change-title', function(e) 
{
    //alert("datas");
    let type = $(this).data('type');
    let invid = $(this).data('invid');
    let category = $(this).data('category');
    let td = $(this).data('testindex');
    let approvaltype = $(this).data('approvaltype');

    //alert(approvaltype);
    e.stopPropagation();
    if($('body').hasClass('cjs-selected-item')){
        $($curEle).text($('.cjs-selected').val()).show();
        $('body').removeClass('cjs-selected-item');
        $('.cjs-badge').remove();
        $('.cjs-selected').remove();
    
    }
    $cjsType = e.target.getAttribute('cjs-badge-type');
    $cjsParam = e.target.getAttribute('cjs-param');
    $curEle = e.target;
    $curEleName = $curEle.nodeName.toLowerCase();
    $curParentEle =  $curEle.parentElement;
    $curEleWidth = $curEle.offsetWidth;
    $('body').addClass('cjs-selected-item');
    CjsTxt = '';
    
    if( $curEleName === 'a' ) {
        e.stopImmediatePropagation();
        e.preventDefault();
    }
    if( $curEleName === 'input' ) {
        // alert('input');
    }else if( $curEleName === 'img' ) {
        // alert('input');
    }else{

        if(type == 'Title' || type == 'Tagline')
        {
			$inputTxt = '<input type="text" onfocus="this.select()" class="cjs-selected titletext" data-invid="'+invid+'" data-category="'+category+'" data-approvaltype="'+approvaltype+'" data-type="'+type+'"data-testindex="'+td+'"  style="width:100%;text-align:center" value="'+$($curEle).text()+'"/>';
            //document.execCommand("selectall", null, false);
            //$cjs_badge_div = '<div class="cjs-badge" ><div class="cjs-badge-copy-text">Copy</div></div>';
            $($curEle).hide();
            $($curEle).after($inputTxt);
        }
        else if((type == 'Number'))
        {
            $inputTxt = '<input type="text" onfocus="this.select()" class="cjs-selected titletext" data-invid="'+invid+'" data-category="'+category+'" data-approvaltype="'+approvaltype+'" data-type="'+type+'"data-testindex="'+td+'"  style="width:100%;text-align:center" value="'+$($curEle).text()+'"/>';
           
            $($curEle).hide();
            $($curEle).after($inputTxt);
        }
        else if((type == 'Website'))
        {
            $inputTxt = '<input type="text" onfocus="this.select()" class="cjs-selected titletext" data-invid="'+invid+'" data-category="'+category+'" data-approvaltype="'+approvaltype+'" data-type="'+type+'"data-testindex="'+td+'"  style="width:100%;text-align:center" value="'+$($curEle).text()+'"/>';
           
            $($curEle).hide();
            $($curEle).after($inputTxt);
        }
        else
        {
            
            $('#descriptionbox').modal("show");
            //$inputTxt = '<div id="editor" class="editor cjs-selected titletext" data-invid="'+invid+'" data-category="'+category+'"  data-type="'+type+'"data-testindex="'+td+'" style="height:500px;width:'+$curEleWidth+'px" value="'+$($curEle).text()+'" style="height:500px;"></div>';
        	/*$inputTxt = '<textarea row="100" cols="50"  class="cjs-selected titletext" data-invid="'+invid+'" data-category="'+category+'"  data-type="'+type+'"data-testindex="'+td+'" style="height:500px;width:'+$curEleWidth+'px" value="'+$($curEle).text()+'">'+$($curEle).text()+'</textarea>';*/
            //$cjs_badge_div = '<div class="cjs-badge" data-badge="" style="width:'+$curEleWidth+'px"><div class="cjs-badge-save"><span class="cjs-save-title">Save</span><span class="cjs-cross">Cancel</span></div></div>';
        }
        if($(this).find('.cjs-change-title').length){
            CjsTxt = '';
        }
        let cjsTop, cjsLeft = 0;
        if($(this).offset().top < 30){
             cjsTop = ($(this).offset().top + $(this).height() + 25) ;
             cjsLeft = ($(this).offset().top ) <= 0 ? $(this).offset().left + 0 : $(this).offset().left - 5;
        
        }else{
             cjsTop = ($(this).offset().top - 35) <= 0 ? 0 : (($(this).offset().top - 45)) ;
             cjsLeft = ($(this).offset().top ) <= 0 ? $(this).offset().left + 0 : $(this).offset().left - 5;
        
        }
        
        //console.log($('.editor'));
        /**/
        $("body .cjs-badge:first").remove();
        $('body').prepend($cjs_badge_div);
        $('.cjs-badge-name').text(CjsTxt);
        $('.cjs-badge').show();
        $('.cjs-badge').css({"top":cjsTop+"px", "left":cjsLeft+"px"});
        

    
    }
   
   
});


// cjs-change-title
$(document).on('change', '.titletext',function(e) 
{
   
    let data1 = $(".cjs-selected").val();
    let type = $(".cjs-selected").data('type');
   
    let approvaltype = $(".cjs-selected").data('approvaltype');
    let category = $(".cjs-selected").data('category');
    let invention_id = $(".cjs-selected").data('invid');
    let testindex = $(".cjs-selected").data('testindex');
    let test_rows = [];
    let total_blocks = $(".testimonialblock");
    if(data1 == '')
    {
        alert("Please Fill Description Box");
    }
    else
    {
        if(type == 'Title' || type == 'Tagline' && data1.match(/^[\x00-\x7F]*$/) != null)
        {
            if(category == 'inventor')
            {
                localStorage.setItem(type,data1);
                localStorage.setItem('inventionkey',true);
                if(approvaltype == 1)
                {
                    alert("If you change invention name, your assigned URL won't change. Please contact admin if you'd like to get that changed.")
                }
                
            }   
            else
            {
                localStorage.setItem('vendorkey',true);
                //alert("here");
                if(approvaltype == 1)
                {
                    alert("If you change company name, your assigned URL won't change. Please contact admin if you'd like to get that changed.")
                }
                localStorage.setItem(type,data1);
               
            }     
            $($curEle).text($('.cjs-selected').val()).show();
            $('body').removeClass('cjs-selected-item');
            $('.cjs-badge').remove();
            $('.cjs-selected').remove();
        }
        else if(type == 'Number' && data1.match(/^[\x00-\x7F]*$/) != null)
        {
            if(category == 'inventor')
            {
                localStorage.setItem(type,data1);
                if(approvaltype == 1)
                {
                    alert("If you change invention name, your assigned URL won't change. Please contact admin if you'd like to get that changed.")
                }
                
            }   
            else
            {
                if(approvaltype == 1)
                {
                    alert("If you change company name, your assigned URL won't change. Please contact admin if you'd like to get that changed.")
                }
                localStorage.setItem(type,data1);
                
            }     
            $($curEle).text($('.cjs-selected').val()).show();
            $('body').removeClass('cjs-selected-item');
            $('.cjs-badge').remove();
            $('.cjs-selected').remove();
        }
        else if(type == 'Website' && data1.match(/^[\x00-\x7F]*$/) != null)
        {
            if(category == 'inventor')
            {
                localStorage.setItem(type,data1);
                if(approvaltype == 1)
                {
                    alert("If you change invention name, your assigned URL won't change. Please contact admin if you'd like to get that changed.")
                }
                
            }   
            else
            {
                //alert("here");
                if(approvaltype == 1)
                {
                    alert("If you change company name, your assigned URL won't change. Please contact admin if you'd like to get that changed.")
                }
                localStorage.setItem(type,data1);
                
            }     
            $($curEle).text($('.cjs-selected').val()).show();
            $('body').removeClass('cjs-selected-item');
            $('.cjs-badge').remove();
            $('.cjs-selected').remove();
        }
        else
        {
            alert("Special characters except (@, #, $, % , ^, &, *, _) are not allowed");
            localStorage.removeItem(type);
        }
    	
    }




  
});
function testdata(id,data,type)
{
    let test_rows = [];
    test_line = {};
   if(type== 'testcomapny')
   {
       test_line.testcompanyname = data;
       //localStorage.setItem("companyname",JSON.stringify(test_line));
   }
   else if(type== 'testauthor')
   {
       test_line.testauthor = data;
       //localStorage.setItem("testauthor",JSON.stringify(test_line));


   }
   else if(type== 'testdesc')
   {
       test_line.testdesc = data;
       //localStorage.setItem("desc",JSON.stringify(test_line));

   }
   else
   {

   }
   test_rows.push(test_line);
    //localStorage.setItem("testimonialarray", test_rows);

   localStorage.setItem("test",JSON.stringify(test_rows));
   
}

$(document).on('click', '.cjs-cross',function(e) {
    $('body').removeClass('cjs-selected-item')
    $($curEle).show();
    $('.cjs-badge').remove();
    $('.cjs-selected').remove();
});


$(document).on('click', '.cjs-save-btn',function(e) {
    var cjs_params_array = {};
    alert($(".cjs-change-title").length);
    $(".cjs-change-title").each(function() {
        var $cjsParamKey = $(this).attr('cjs-param');
        var $cjsParamVal = $(this).text();
        $cjsParamKey = $(this).attr('cjs-param');
        console.log($cjsParamKey);
        console.log($cjsParamVal);
        
        cjs_params_array[$cjsParamKey] = $cjsParamVal;
        
    });
    if(Object.keys(cjs_params_array).length){
        console.log(JSON.stringify(cjs_params_array));
        console.log(cjs_params_array);
        $.ajax({
            type: 'POST',
            url: "index.php",
            data: JSON.stringify(cjs_params_array),
            beforeSend:function(){
                $('.cjs-loader').show();
            },
            success: function(resultData) { alert("Save Complete") }
      });
    }
    
});



$(document).on("click", ".descsave", function()
{
    let quilldesc = JSON.stringify(quill.getContents());
    let  desc= quill.root.innerHTML;
    //console.log(quill.root.innerHTML);
    $('#desc').html(desc);
    localStorage.setItem("Description",quilldesc);
    localStorage.setItem('inventionkey',true);
    localStorage.setItem('vendorkey',true);


    $('#descriptionbox').modal("hide");
});

/*let Size = Quill.import('attributors/style/size');
console.log(Size);
Size.whitelist = ['12px', '14px', '16px', '18px','20px'];
Quill.register(Size, true);
   

$(document).ready(function() 
{
    quill = new Quill('.editor', 
    {
        modules:{
                    toolbar: 
                    [
                        [{ size: ['12px','14px', '16px','18px','20px'] }],
                        [{ header: [1, 2, 3, 4, 5, 6, false]  }],
                        [{ 'color': [] }, { 'background': [] }],
                        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                        ['bold', 'italic', 'underline', 'link','strike'],
                        ['blockquote', 'code-block'],
                        [{ 'indent': '-1'}, { 'indent': '+1' }],
                        [{ 'align': [] }],
                        [{ 'font': [] }],
                        [{ 'size': ['14px', '16px', '18px'] }],
                        
                        ['image']
                    ]
                },
                placeholder: 'Content here...',
                theme: 'snow'  
    }); 
    let name = $('#editordecriptioncontent').val();
    if(name != '' && name != ' ')
    {
        quill.setContents(JSON.parse(name));
    }
});*/


$(document).ready(function() 
{
    quill = new Quill('.editor', 
    {
        modules:{
                    toolbar: 
                    [
                        [{ header: [1, 2, 3, 4, 5, 6, false]  }],
                        [{ 'color': [] }, { 'background': [] }],
                        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                        ['bold', 'italic', 'underline', 'link'],
                        ['image'],
                        ['video'],
                    ]
                },
                placeholder: 'Content here...',
                theme: 'snow'  
    }); 
    let name = $('#editordecriptioncontent').val();
    if(name != '' && name != ' ')
    {
        quill.setContents(JSON.parse(name));
    }
});


$(document).on("click", "#preview", function(e)
{
        e.preventDefault();
        $("#description").val(JSON.stringify(quill.getContents()));
        $("#type").val('preview');
        $('#AddContent').submit();

});
$(document).on("submit", "#editcontent", function(e)
{
    e.preventDefault();
    $("#description").val(JSON.stringify(quill.getContents()));
    this.submit();
});

$(document).on("click", "#exit", function(e)
{
    e.preventDefault();
    $("#description").val(JSON.stringify(quill.getContents()));
    $("#type").val('exit');
    $('#AddContent').submit();
});
$(document).on("click", "#editpreview", function(e)
{
    e.preventDefault();
    $("#description").val(JSON.stringify(quill.getContents()));
    $("#type").val('preview');
    $('#editcontent').submit();
});
$(document).on("click", "#editexit", function(e)
{
    e.preventDefault();
    $("#description").val(JSON.stringify(quill.getContents()));
    $("#type").val('exit');
    $('#editcontent').submit();
});





//page
$(document).on("click", "#pagepreview", function(e)
{
        e.preventDefault();
        $("#description").val(JSON.stringify(quill.getContents()));
        $("#type").val('preview');
        $('#AddPageContent').submit();

});
$(document).on("submit", "#pageeditcontent", function(e)
{
    e.preventDefault();
    $("#description").val(JSON.stringify(quill.getContents()));
    this.submit();
});

$(document).on("click", "#pageexit", function(e)
{
    e.preventDefault();
    $("#description").val(JSON.stringify(quill.getContents()));
    $("#type").val('exit');
    $('#AddPageContent').submit();
});

